import { LiquidacionCapturaService } from './../../../services/liquidacion-captura.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LiquidacionCapturaMovimientosObraService } from './../../../services/liquidacion-captura-movimientos-obra.service';
import { ValidatorService } from '../../../services/tools/validator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../../tools/modals/confirm-modal/confirm-modal.component';
import {CuentasService} from "../../../services/cuentas.service";
import {ConceptosService} from "../../../services/conceptos.service";
import {ProveedoresService} from "../../../services/proveedores.service";
import {HelpersService} from "../../../services/tools/helpers.service";
import {WarningModalComponent} from "../../tools/modals/warning-modal/warning-modal.component";
declare var $;


@Component({
  selector: 'app-movimientos-obra-liquidacion',
  templateUrl: './movimientos-obra-liquidacion.component.html',
  styleUrls: ['./movimientos-obra-liquidacion.component.scss']
})
export class MovimientosObraLiquidacionComponent implements OnInit {
  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(WarningModalComponent) warningModal: WarningModalComponent;

  movimientosObra: any[];
  totales: any;
  searchText: string = "";
  mostrarListado: boolean = true;
  errors: any = {};
  searchProcess: any;
  paginate: any = {};
  fechaActual: string;
  fechaInicioLiquidacion: string;
  fechaFinLiquidacion: string;
  currentPage: any = 1;
  lastPage: any = 1;
  processing: any = false;
  alterTable: any = 'starting';
  exportingCSV: any = false;
  /* selected */
  liquidacionSelected: any = undefined;
  movimientosObraSelected: any;
  conceptosSelectedOptions: any = [];
  cuentasSelectedOptions: any = [];
  proveedoresSelectedOptions: any = [];
  notasUrl: string;
  fondoUrl: string;

  //mostrar dato
  tipoMov : any;
  private passwordActived:any;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  //CL
  private idLiquidacion:any;

  constructor(  private liquidacionCapturaMovimientosObraService: LiquidacionCapturaMovimientosObraService,
                private liquidacionCapturaService: LiquidacionCapturaService,
                private cuentasService: CuentasService,
                private conceptosService: ConceptosService,
                private proveedoresService: ProveedoresService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private activedRoute: ActivatedRoute,
                private router: Router) {
    this.getIdLiquidacion();
    //binding functions
    this.resetMovimientosObraSelected = this.resetMovimientosObraSelected.bind(this);
    this.deleteMovimientoObra = this.deleteMovimientoObra.bind(this);
    this.updateMovimientosObraCheque = this.updateMovimientosObraCheque.bind(this);
    this.deleteLiquidacion = this.deleteLiquidacion.bind(this);
    this.sendLiquidacion = this.sendLiquidacion.bind(this);
  }

  ngOnInit() {
    this.getIdLiquidacion();
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  getIdLiquidacion() {
    this.idLiquidacion = this.activedRoute.snapshot.params.id;
    this.notasUrl = '/liquidacion-captura/' + this.idLiquidacion +'/notas-fotografias';
    this.fondoUrl = '/liquidacion-captura/' + this.idLiquidacion +'/fondo-ahorro';
    if (this.idLiquidacion) {
      this.getLiquidacion();
    } else {
      console.log('dont found id liquidacion');
      this.regresar();
    }
  }

  start() {
    this.getFechaActual();
    this.getProveedores();
    this.getCuentas();    
  }

  resetMovimientosObraSelected() {
    this.movimientosObraSelected = undefined;
    this.errors = {};
  }

  startMovimientosObraSelected() {
    this.resetMovimientosObraSelected();
    console.log('start date ', this.fechaFinLiquidacion);
    const mos = this.liquidacionCapturaMovimientosObraService.getDefaultSchedule(this.fechaFinLiquidacion);
    console.log('temporal mos ', mos);
    this.movimientosObraSelected = mos;
    if (this.canEdit()) {
      this.movimientosObraSelected.obras = this.liquidacionSelected.obras;
    }
    this.changeTipoMovimiento( this.movimientosObraSelected.tipoMovimiento );
  }

  canEdit() {
    return (this.liquidacionSelected && (this.liquidacionSelected.estado == 0 || this.liquidacionSelected.estado == 2));
  }

  selectMovimientosObra(movimientosObra) {
    this.resetMovimientosObraSelected();

    const movimientosObraCloned = JSON.parse(JSON.stringify( movimientosObra ));
    this.movimientosObraSelected = movimientosObraCloned;
    this.changeTipoMovimiento( this.movimientosObraSelected.tipoMovimiento );
  }

  SelectedMovimientosObraClass(movimientosObra) {
    return (this.validatorService.required(this.movimientosObraSelected) &&
        this.movimientosObraSelected.idLiquidacion_Movimientos == movimientosObra.idLiquidacion_Movimientos) ? 'active' : '';
  }
  
  searchMovimientosObra(page = null) {
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }
    if (this.searchText.length > 1) {
      this.getTotales();
      this.searchProcess = this.liquidacionCapturaMovimientosObraService.searchMovimientosObraByLiquidacion(this.searchText, this.idLiquidacion, page)
          .subscribe(response => {
            const content = response.json().content;
            this.movimientosObra = content.data;
            this.searchProcess = false;
            this.startPaginate(content);
            this.alterTable = (this.movimientosObra.length > 0)? false: 'not_found';
          });
    } else {
      this.getMovimientosObra(1);
    }
  }

  getLiquidacion() {
    this.liquidacionCapturaService.getLiquidacionByID(this.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.liquidacionSelected = content_response;
        this.liquidacionSelected.fecha_formated = this.helperService.getMonthYearByDate(this.liquidacionSelected.fechaLiquidacion);
        this.start();
      }, error => {
        const content_error = error.json().content;
        // resuelve errores 403, 500 y sin internet
        this.helperService.httpGlobalError(error);

        if (error.status == 400 && content_error.id) {
          this.router.navigate(['/'])
        }
      })

  }

  getFechaActual() {
    this.liquidacionCapturaMovimientosObraService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fechaActual = content.fecha;
          this.fechaInicioLiquidacion = content.fecha_inicio;
          this.fechaFinLiquidacion = content.fecha_fin;
          this.getMovimientosObra(); // se inicia la carga del listado general
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }

  getTotales() {
    this.liquidacionCapturaMovimientosObraService.getTotales(this.idLiquidacion)
      .subscribe((response) => {
        const respuesta = response.json();
        this.totales = respuesta.content;
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);
          
        if (error == 400) {
          console.log('getTotales - error 400 ' , error);
        }
      });
  }

  getMovimientosObra(page = null) {
    this.getTotales();
    this.searchProcess = this.liquidacionCapturaMovimientosObraService.getMovimientosObraByLiquidacion(this.idLiquidacion, page)
        .subscribe(response => {
          const content = response.json().content;
          this.movimientosObra = content.data;
          this.startPaginate(content);
          this.searchProcess = false;
          this.alterTable = (this.movimientosObra.length > 0)? false: 'not_result';
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
            
          if (error == 400) {
            console.log('getMovimientosObra - error 400 ' , error);
          }
        });
  }

  getProveedores() {
    const proveedoresSelectedOptions = [];
      this.proveedoresSelectedOptions = [];
      this.proveedoresService.getProveedoresAndInversionistas(this.liquidacionSelected.obras.idObras, '/movimientos')
      .subscribe((response) => {
        const respuesta = response.json();
        proveedoresSelectedOptions.push({
          'text': 'Proveedores',
          'children': respuesta.content.proveedores,
          'key': 'idProveedores',
          'label': 'nombre'
        });
        proveedoresSelectedOptions.push({
          'text': 'Inversionistas',
          'children': respuesta.content.inversionistas,
          'key': 'idInversionistas',
          'label': 'nombre'
        });
        this.proveedoresSelectedOptions = proveedoresSelectedOptions;
      }, error => {
        this.proveedoresSelectedOptions = proveedoresSelectedOptions;
      });
  }

  getCuentas() {
    //Hay que obtener las cuentas normales y las cuentas de tipo sobre. Ya que las liquidaciones tiene ambos tipos de movimientos
    this.cuentasService.getCuentasMixtas({ idObras: this.liquidacionSelected.obras.idObras})
      .subscribe(response => {
        const content_response = response.json().content;
        this.cuentasSelectedOptions = content_response;
      })
  }
  
  createMovimientosObra() {
    this.errors = [];
    this.errors = this.liquidacionCapturaMovimientosObraService.validateMovimientosObra(this.movimientosObraSelected);


    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.movimientosObraSelected.idObras = this.liquidacionSelected.obras.idObras;
    this.movimientosObraSelected.idLiquidacion = this.liquidacionSelected.idLiquidacion;
    this.movimientosObraSelected.idCuentas = this.movimientosObraSelected.cuentas_mixtas.idCuentas;
    this.movimientosObraSelected.idConceptos = this.movimientosObraSelected.conceptos.idConceptos;
    this.movimientosObraSelected.numero = this.movimientosObraSelected.numero.toString();
    this.movimientosObraSelected.chequeCancelado = (this.movimientosObraSelected.chequeCancelado)? 1: 0;
    this.movimientosObraSelected.chequeConciliado = (this.movimientosObraSelected.chequeConciliado)? 1: 0;
    this.movimientosObraSelected.chequeTransferencia = (this.movimientosObraSelected.chequeTransferencia)? 1: 0;
    this.movimientosObraSelected.enviadoCfdi = (this.movimientosObraSelected.enviadoCfdi)? 1: 0;
    
    if (this.validatorService.required(this.movimientosObraSelected.proveedores.idInversionistas)){
      this.movimientosObraSelected.idInversionistas = this.movimientosObraSelected.proveedores.idInversionistas;
      this.movimientosObraSelected.idProveedores = null;
    } else if (this.validatorService.required(this.movimientosObraSelected.proveedores.idProveedores)){
      this.movimientosObraSelected.idProveedores = this.movimientosObraSelected.proveedores.idProveedores;
      this.movimientosObraSelected.idInversionistas = null;
    }

    console.log('data to save ', this.movimientosObraSelected);

    this.liquidacionCapturaMovimientosObraService.createMovimientosObra(this.movimientosObraSelected)
        .subscribe(response => {
          const respuesta = response.json();
          this.processing = false;
          if (respuesta.success) {
            this.successModal.open({
              'title': '¡Éxito!',
              'description': 'Se ha creado correctamente el movimiento de obra'
            });
            this.movimientosObraSelected.idLiquidacion_Movimientos = respuesta.content.id;
            this.movimientosObraSelected.importeLetras = respuesta.content.importeLetras;
            this.goPage(1);
          }
        }, error => {
          // se revisan errores 403 - 500
          this.processing = false;
          this.helperService.httpGlobalError(error, false);

          if (error == 400) {
            this.setBackendErrors(error.json().content);
            console.log('getMovimientosObra - error 400 ' , error);
          } 

          if (error == 400 || error == 500) {
            // usamos modal en vez de notification
            this.errorModal.open({
              'title': 'ERROR',
              'description': 'No se pudo completar la acción solicitada. Por favor, intente más tarde.'
            });
          }
        });
  }

  updateMovimientosObra() {
    this.errors = [];
    this.errors = this.liquidacionCapturaMovimientosObraService.validateMovimientosObra(this.movimientosObraSelected);


    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.movimientosObraSelected.idCuentas = this.movimientosObraSelected.cuentas_mixtas.idCuentas;
    this.movimientosObraSelected.idConceptos = this.movimientosObraSelected.conceptos.idConceptos;
    this.movimientosObraSelected.numero = this.movimientosObraSelected.numero.toString();
    this.movimientosObraSelected.chequeCancelado = (this.movimientosObraSelected.chequeCancelado)? 1: 0;
    this.movimientosObraSelected.chequeConciliado = (this.movimientosObraSelected.chequeConciliado)? 1: 0;
    this.movimientosObraSelected.chequeTransferencia = (this.movimientosObraSelected.chequeTransferencia)? 1: 0;
    this.movimientosObraSelected.enviadoCfdi = (this.movimientosObraSelected.enviadoCfdi)? 1: 0;
    if (this.validatorService.required(this.movimientosObraSelected.proveedores.idInversionistas)){
      console.log('se ha localizado inversionista ', this.movimientosObraSelected.proveedores.idInversionistas);
      this.movimientosObraSelected.idInversionistas = this.movimientosObraSelected.proveedores.idInversionistas;
      this.movimientosObraSelected.idProveedores = null;
    } else if (this.validatorService.required(this.movimientosObraSelected.proveedores.idProveedores)){
      console.log('se ha localizado proveedores', this.movimientosObraSelected.proveedores.idProveedores);
      this.movimientosObraSelected.idProveedores = this.movimientosObraSelected.proveedores.idProveedores;
      this.movimientosObraSelected.idInversionistas = null;
    }

    console.log('data to edit ', this.movimientosObraSelected);
    
    this.liquidacionCapturaMovimientosObraService.updateMovimientosObra(this.movimientosObraSelected, this.movimientosObraSelected.idLiquidacion_Movimientos)
        .subscribe(response => {
          const respuesta = response.json();
          this.processing = false;
          if (response.json().success) {
            this.helperService.notification('Movimiento de obra guardado', 'Se guardaron correctamente los datos del movimiento de obra', 'success');
            this.movimientosObraSelected.importeLetras = respuesta.content.importeLetras;
            this.goPage(this.currentPage);
          }
        }, error => {
          this.processing = false;

          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        });
  }

  confirmConciliarCheque() {
    if(this.movimientosObraSelected.chequeConciliado == 1){
      this.tipoMov = 0;
    }else{
      this.tipoMov = 1;
    }
    this.confirmModal.open({
      'color': 'success',
      'title': 'Conciliar cheque',
      'description': '¿Está seguro de conciliar el cheque?',
      'callback': this.updateMovimientosObraCheque,
      'callbackClose':this.goPage(this.currentPage),
    });
  }

  updateMovimientosObraCheque() {
    this.movimientosObraSelected.chequeConciliado = this.tipoMov;
    this.liquidacionCapturaMovimientosObraService.updateMovimientosObra(this.movimientosObraSelected, this.movimientosObraSelected.idLiquidacion_Movimientos)
        .subscribe(response => {
          this.processing = false;
          if (response.json().success) {
            this.helperService.notification('Movimiento de obra guardado', 'Se guardaron correctamente los datos del movimiento de obra', 'success');
            this.goPage(this.currentPage);
          }
        }, error => {
          this.processing = false;

          // se resuelven errores 403 y 500
          this.helperService.httpGlobalError(error);

          if (error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        });
  }

  confirmDeleteMovimientoObra() {
    this.confirmModal.open({
      'color': 'danger',
      'title': 'Eliminar movimiento',
      'description': "¡ATENCIÓN! <br> Está a punto de eliminar el movimiento de obra.",
      'callback': this.deleteMovimientoObra
    });
  }

  deleteMovimientoObra() {
    this.processing = true;
    this.liquidacionCapturaMovimientosObraService.deleteMovimientoObra(this.movimientosObraSelected.idLiquidacion_Movimientos)
        .subscribe(
            response => {
              const movimientosObraDeleted = JSON.parse(JSON.stringify( this.movimientosObraSelected ));
              this.processing = false;
              this.successModal.open({
                'title': 'Movimiento eliminado',
                'description': 'El movimiento con datos: <br> Obra: ' + this.liquidacionSelected.obras.nombreObra + ' <br> Cuenta: ' + movimientosObraDeleted.cuentas.nombreCuenta + '<br> Ha sido eliminado.'
              });

              this.goPage(this.currentPage);
              this.resetMovimientosObraSelected();
            }, error => {
              this.processing = false;
              
              // se resuelve los errores 403 y 500, no se requiere notification
              this.helperService.httpGlobalError(error, false);

              if (error.status == 400 || error.status == 500) {
                this.errorModal.open({
                  'title': 'Error',
                  'description': 'Ha ocurrido un error al intentar eliminar el movimiento de obra, inténtelo más tarde'
                });
              }

            });
  }

  confirmSendLiquidacion() {
    this.confirmModal.open({
      'title': 'Liquidación',
      'description': 'Enviar a revisión <br/> ¿Desea enviar a revisión la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'color': 'success',
      'text': 'Enviar',
      'callback': this.sendLiquidacion
    });
  }

  sendLiquidacion() {
    this.liquidacionCapturaService.sendLiquidacion(this.liquidacionSelected.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.helperService.notification('Liquidación Enviada', 'Se ha enviado a revisión la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?', 'success');
        this.regresar()
      }, error => {
        console.log('error sendLiquidación ', error);
        this.helperService.httpGlobalError(error);
      })
  }

  confirmDeleteLiquidacion() {
    console.log('this.liquidacion selected ', this.liquidacionSelected);
    this.confirmModal.open({
      'title': 'Eliminar liquidación',
      'description': '¿Desea eliminar la liquidación ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'callback': this.deleteLiquidacion,
      'color': 'danger'
    });
  }
  deleteLiquidacion() {
    this.liquidacionCapturaService.deleteLiquidacion(this.idLiquidacion)
      .subscribe(response => {
        console.log('delete liq response ', response);
        this.helperService.notification('Liquidación eliminada', 'La liquidación ha sido eliminada.', 'success');
        this.regresar();
      }, error => {
      })
  }

  changeTipoMovimiento(tipoMovimiento) {
    if (!this.canEdit()) {
      if (tipoMovimiento != 4) {

        this.movimientosObraSelected.tipoMovimiento = tipoMovimiento;
        this.conceptosService.getConceptosByTipoMovimientoToSelect(tipoMovimiento, this.liquidacionCapturaMovimientosObraService.modulo_url)
            .subscribe((response) => {
              this.conceptosSelectedOptions = response.json().content;
          });
      }
      return false;
    }
    // no se pueden modificar a 4
    if (tipoMovimiento != 4) {

      this.movimientosObraSelected.tipoMovimiento = tipoMovimiento;
      this.conceptosService.getConceptosByTipoMovimientoToSelect(tipoMovimiento, this.liquidacionCapturaMovimientosObraService.modulo_url)
          .subscribe((response) => {
            this.conceptosSelectedOptions = response.json().content;
        });
    }
  }

  changeConceptoSelected(conceptoSelected) {
    this.movimientosObraSelected.conceptos = conceptoSelected;
  }
  isTipoMovimiento( tipoMovimiento, movimiento = null) {
    if (!this.validatorService.required(this.movimientosObraSelected) && !movimiento) {
      return false;
    }

    if (!movimiento) {
      movimiento = this.movimientosObraSelected;
    }

    if (tipoMovimiento == movimiento.tipoMovimiento && movimiento.conceptos.traspaso != 1) {
      return true;
    }
    return false;
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];

    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  movimientosObraSelectedWithId(){
    if(! this.movimientosObraSelected)
      return false;

    return (this.validatorService.required(this.movimientosObraSelected.idLiquidacion_Movimientos));
  }

  cancelarMovimientosObraSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetMovimientosObraSelected
    });
  }
  
  getTipoMovimiento( movimiento ) {
    return (movimiento.tipoMovimiento == 2) ? 'INGRESO' : 'EGRESO';
  }

  regresar() {
    console.log('regresando a vista anterior');
    this.router.navigate(["/liquidacion-captura"]);
  }

  hasNotasRechazo() {
    return this.liquidacionSelected && this.liquidacionSelected.estado == 2 && this.liquidacionSelected.notasRechazo && this.canEdit();
  }

  hasMovimientos() {
    return this.movimientosObra && this.movimientosObra.length > 0;
  }

  writePermission() {
    return this.liquidacionCapturaService.writePermission();
  }

  canExport() {
    return this.liquidacionCapturaService.canExport();
  }

  exportCSV() {
    this.exportingCSV = true;
    this.liquidacionCapturaMovimientosObraService.exportCSV(this.idLiquidacion)
      .subscribe((response) => {
        this.exportingCSV = false;
      }, (error) => {
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  // MODAL FUNCTIONS

  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for (let i = 1; i <= this.paginate.last_page; i++) {
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {
    if (this.searchText) {
      this.searchMovimientosObra(page);
    } else {
      this.getMovimientosObra(page);
    }
  }

  changeSwitchListado(){
    if(!this.mostrarListado){
      this.movimientosObraSelected = this.liquidacionCapturaMovimientosObraService.getDefaultSchedule(this.fechaInicioLiquidacion);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/components/liquidacion-captura/movimientos-obra-liquidacion/movimientos-obra-liquidacion.component.ts